import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import IconButton from '@mui/material/IconButton';
import { useTheme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { motion } from 'framer-motion';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import {
  RanchAreaEnum,
  selectRanchFocusArea,
  setRanchFocusArea,
} from '../ranchesSlice';

interface Props {
  gridArea: RanchAreaEnum;
}

const RanchAreaFullscreenToggle: React.FC<Props> = ({ gridArea }) => {
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const focusedArea = useAppSelector(selectRanchFocusArea);

  const iconStyles: SxProps = {
    color: theme.colors.common.white,
  };

  const handleFocusAreaClick = (
    e: React.MouseEvent<HTMLElement>,
    gridArea: RanchAreaEnum
  ) => {
    if (focusedArea !== null) {
      dispatch(setRanchFocusArea(null));
    } else {
      dispatch(setRanchFocusArea(gridArea));
    }
  };

  return (
    <motion.div
      layout
      style={{
        position: 'absolute',
        top: 11,
        right: 11,
        zIndex: 10,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <IconButton
        aria-label='FullScreen Toggle'
        size='small'
        onClick={(e) => handleFocusAreaClick(e, gridArea)}
      >
        {focusedArea === gridArea ? (
          <FullscreenExitIcon sx={{ ...iconStyles }} />
        ) : (
          <FullscreenIcon sx={{ ...iconStyles }} />
        )}
      </IconButton>
    </motion.div>
  );
};

export default RanchAreaFullscreenToggle;
